var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconVerticalEllipsis(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6 3.25C6.89746 3.25 7.625 2.52246 7.625 1.625C7.625 0.727537 6.89746 0 6 0C5.10254 0 4.375 0.727537 4.375 1.625C4.375 2.52246 5.10254 3.25 6 3.25Z",
    fill: "#0088A9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 7.625C6.89746 7.625 7.625 6.89746 7.625 6C7.625 5.10254 6.89746 4.375 6 4.375C5.10254 4.375 4.375 5.10254 4.375 6C4.375 6.89746 5.10254 7.625 6 7.625Z",
    fill: "#0088A9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 12C6.89746 12 7.625 11.2725 7.625 10.375C7.625 9.47754 6.89746 8.75 6 8.75C5.10254 8.75 4.375 9.47754 4.375 10.375C4.375 11.2725 5.10254 12 6 12Z",
    fill: "#0088A9"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconVerticalEllipsis);
export default __webpack_public_path__ + "static/media/icon-vertical-ellipsis.26243dc578192b0762797a56f9acd3dd.svg";
export { ForwardRef as ReactComponent };